import { render, staticRenderFns } from "./session-storage.vue?vue&type=template&id=f316dde0"
import script from "./session-storage.vue?vue&type=script&lang=js"
export * from "./session-storage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports